<template>
	<div class="sign-up-container form-container">
		<div class="center-message">
			<p>Create an account with us</p>
		</div>
		<div class="contact-form">
			<div class="contact-field" :class="validateClass(hasValidName(guestNameModel))">
				<input class="input text-input" type="text" placeholder="Your Name" v-model="guestNameModel" @blur="updateName()" />
			</div>
			<div class="contact-field" :class="updatePhoneClass()">
				<BaseIcon
					class="input-field-icon icon-mobile"
					icon="mobile"
					:isCustom="true"
					size="1x"/>
				<input class="input text-input has-icon" type="tel" placeholder="Mobile Number" v-model="phone" @blur="updatePhone()" />
			</div>
			<div class="contact-field">
				<BaseButton
					:classNames="['button--modifier', 'input-field-button']"
					title="Sign Up"
					type="scaleable-fixed-square"
					:disabled="!validateAccount()"
					@click="handleClickSignUp"/>
			</div>
		</div>
		<div class="center-flex-inline">
			<p>Already have an account? <span class="link" @click="handleClickSignIn">Sign in</span></p>
		</div>
	</div>
</template>

<script>
	import contactDetailsMixin from '@Mixin/contactDetailsMixin';
	import loginMixin from '@Mixin/loginMixin';
	import headerMixin from '@Mixin/headerMixin';
	import accountMixin from '@Mixin/accountMixin';

	export default {
		mixins: [
			contactDetailsMixin,
			loginMixin,
			headerMixin,
			accountMixin,
		],
		methods: {
			handleClickSignUp() {
				this.sendLoginRequest().then((response) => {
					const data = response.data;
					const newAccount = data.body.new_acount // TODO (server side) change new_acount to new_account
					this.setIsNewAccount(newAccount);
					this._navigateToPin();
				});
			},
			handleClickSignIn() {
				this._navigateToSignIn();
			},
		},
		mounted() {
			this._setHeaderTitle('Sign Up');
		}
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/checkout';
	@import 'commonStyle/contactForm';
</style>


// WEBPACK FOOTER //
// src/components/account/SignUp.vue